<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <storage-space-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></storage-space-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import StorageSpaceCreate from './StorageSpaceCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    StorageSpaceCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>